export const ActionTypes =
{
    CHECK_LOGGED: 'CHECK_LOGGED',
    LOGIN: 'LOGIN',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAIL: 'LOGIN_FAIL',
    LOGOUT: 'LOGOUT',
    LOGOUT_FAIL: 'LOGOUT_FAIL',

    GET_USER_DATA: 'GET_USER_DATA',
    GET_ALL_USER_DATA_ATTEMPT: 'GET_ALL_USER_DATA_ATTEMPT',
    GET_ALL_USER_DATA_FAIL: 'GET_ALL_USER_DATA_FAIL',
    GET_ALL_USER_DATA_SUCCESS: 'GET_ALL_USER_DATA_SUCCESS',

    REGISTER_ATTEMPT: 'REGISTER_ATTEMPT',
    REGISTER_FAIL: 'REGISTER_FAIL',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',


    SET_PROFILE: 'SET_PROFILE',
    SET_PROFILE_FAIL: 'SET_PROFILE_FAIL',
    PROFILE_UPDATE_ATTEMPT: 'PROFILE_UPDATE_ATTEMPT',
    PROFILE_UPDATE_FAIL: 'PROFILE_UPDATE_FAIL',
    PROFILE_UPDATE_SUCCESS: 'PROFILE_UPDATE_SUCCESS',


    UPDATE_FORM: "UPDATE_FORM",

    UPLOAD_FORM_ATTEMPT: 'UPLOAD_FORM_ATTEMPT',
    UPLOAD_FORM_SUCCESS: 'UPLOAD_FORM_SUCCESS',
    UPLOAD_FORM_FAIL: 'UPLOAD_STORY_FAIL',


    FETCH_ALL_FORMS_ATTEMPT: 'FETCH_ALL_FORMS_ATTEMPT',
    FETCH_ALL_FORMS_SUCCESS: 'FETCH_ALL_FORMS_SUCCESS',
    FETCH_ALL_FORMS_FAIL: 'FETCH_ALL_FORMS_FAIL',
    SET_CURRENT_FORM: 'SET_CURRENT_FORM',

    FETCH_ALL_QUESTIONS_ATTEMPT: 'FETCH_ALL_QUESTIONS_ATTEMPT',
    FETCH_ALL_QUESTIONS_SUCCESS: 'FETCH_ALL_QUESTIONS_SUCCESS',
    SET_QUESTIONS: 'SET_QUESTIONS',
    ADD_QUESTION: 'ADD_QUESTION',
    REMOVE_QUESTION: 'REMOVE_QUESTION',
    REORDER_QUESTIONS: 'REORDER_QUESTIONS',
    UPDATE_QUESTIONS: 'UPDATE_QUESTIONS',
    UPDATE_THEME: 'UPDATE_THEME',
    UPDATE_OPTIONS: 'UPDATE_OPTIONS',

    TOGGLE_FORM_VISIBILITY: 'TOGGLE_FORM_VISIBILITY',

    UPDATE_FORM_DETAILS: 'UPDATE_FORM_DETAILS',



    VIEW_SINGLE_FORM: 'VIEW_SINGLE_FORM',



}